<dialog-draggable-header>Add Program</dialog-draggable-header>

<gm-loading-spinner *ngIf="loading"></gm-loading-spinner>

<div mat-dialog-content>
   <form class="flex-dialog-container" [formGroup]="addProgramForm">

      <div class="space-between-items">
         <mat-checkbox color="primary" formControlName="newProgram">New?</mat-checkbox>
         <mat-checkbox color="primary" formControlName="ecm">Used by ECM?</mat-checkbox>
         <mat-checkbox id="active" color="primary" formControlName="active">Active?</mat-checkbox>
         <mat-checkbox id="noLitigationHold" color="primary" formControlName="noLitigationHold">No Litigation Hold?
         </mat-checkbox>
      </div>

      <mat-form-field>
         <mat-label for="program-name">Program Name</mat-label>
         <input id="program-name" matInput formControlName="mescProgram" [matAutocomplete]="programNameAuto"
            autocomplete="off" />
         <mat-autocomplete #programNameAuto [displayWith]="displayMescPrograms">
            <mat-option *ngFor="let p of filteredMescPrograms$ | async" [value]="p">
               {{p.programName}}
            </mat-option>
         </mat-autocomplete>
         <mat-error *ngIf="this.addProgramForm.get('mescProgram').hasError('noMescId')">
            Select a MESC program from dropdown options
         </mat-error>
      </mat-form-field>

      <div class="d-flex">
         <mat-form-field class="full-width pr-4">
            <mat-label for="egm">EGM</mat-label>
            <input id="egm" matInput formControlName="manager2" [matAutocomplete]="egmAuto" autocomplete="off" />
            <mat-autocomplete #egmAuto [displayWith]="displayEngineers">
               <mat-option *ngFor="let e of filteredEgm$ | async" [value]="e">{{e.lastFirstName}}</mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="this.addProgramForm.get('manager2').hasError('noManager2Id')">
               Select an EGM from dropdown options or clear field
            </mat-error>
         </mat-form-field>

         <mat-form-field class="full-width">
            <mat-label for="engineer">Engineer</mat-label>
            <input id="engineer" matInput formControlName="engineer2" [matAutocomplete]="engineerAuto"
               autocomplete="off" />
            <mat-autocomplete #engineerAuto [displayWith]="displayEngineers">
               <mat-option *ngFor="let e of filteredEngineers$ | async" [value]="e">{{e.lastFirstName}}</mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="this.addProgramForm.get('engineer2').hasError('noEngineer2Id')">
               Select an Engineer from dropdown options or clear field
            </mat-error>
         </mat-form-field>
      </div>

      <div class="d-flex">
         <mat-form-field class="full-width pr-4">
            <mat-label>SOP Date</mat-label>
            <input matInput [matDatepicker]="sopDatePicker" formControlName="sop" />
            <mat-datepicker-toggle matSuffix [for]="sopDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #sopDatePicker></mat-datepicker>
            <mat-error *ngIf="this.addProgramForm.get('sop').hasError('required')">
               Must have an SOP date if Active
            </mat-error>
         </mat-form-field>

         <mat-form-field class="full-width pr-4">
            <mat-label>CVER or A1R Date</mat-label>
            <input matInput [matDatepicker]="fe31Date" formControlName="fe31" />
            <mat-datepicker-toggle matSuffix [for]="fe31Date"></mat-datepicker-toggle>
            <mat-datepicker #fe31Date></mat-datepicker>
         </mat-form-field>

         <mat-form-field class="full-width">
            <mat-label>SVER or A2R Date</mat-label>
            <input matInput [matDatepicker]="fe32Date" formControlName="fe32" />
            <mat-datepicker-toggle matSuffix [for]="fe32Date"></mat-datepicker-toggle>
            <mat-datepicker #fe32Date></mat-datepicker>
         </mat-form-field>
      </div>

      <div class="d-flex">
         <mat-form-field class="full-width pr-4">
            <mat-label>IVER or Beta Date</mat-label>
            <input matInput [matDatepicker]="fe33Date" formControlName="fe33" />
            <mat-datepicker-toggle matSuffix [for]="fe33Date"></mat-datepicker-toggle>
            <mat-datepicker #fe33Date></mat-datepicker>
         </mat-form-field>

         <mat-form-field class="full-width pr-4">
            <mat-label>Body Shop Test Date</mat-label>
            <input matInput [matDatepicker]="bodyShopTestDate" formControlName="bodyShopTest" />
            <mat-datepicker-toggle matSuffix [for]="bodyShopTestDate"></mat-datepicker-toggle>
            <mat-datepicker #bodyShopTestDate></mat-datepicker>
         </mat-form-field>

         <mat-form-field class="full-width">
            <mat-label>Hem Pass 1 Date</mat-label>
            <input matInput [matDatepicker]="hemPass1Date" formControlName="hemPass2" />
            <mat-datepicker-toggle matSuffix [for]="hemPass1Date"></mat-datepicker-toggle>
            <mat-datepicker #hemPass1Date></mat-datepicker>
         </mat-form-field>
      </div>

      <div class="d-flex">
         <mat-form-field class="full-width pr-4">
            <mat-label>End of Production Date</mat-label>
            <input matInput [matDatepicker]="endOfProductionDate" formControlName="endOfProduction" />
            <mat-datepicker-toggle matSuffix [for]="endOfProductionDate"></mat-datepicker-toggle>
            <mat-datepicker #endOfProductionDate></mat-datepicker>
         </mat-form-field>
         <div class="full-width pr-4"></div>
         <div class="full-width"></div>
      </div>
   </form>

</div>
<div mat-dialog-actions class="mat-dialog-actions-end no-margin">
   <button mat-raised-button color="primary" [disabled]="!this.addProgramForm.valid" (click)="onAddClick()"
      (keypress.enter)="onAddClick()">Save</button>
   <button mat-raised-button mat-dialog-close cdkFocusInitial (click)="onCloseClick()"
      (keypress.enter)="onCloseClick()">Cancel</button>
</div>